@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.fodmap.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.fodmap.composeapp.generated.resources/"

@delegate:ResourceContentHash(-2_140_060_987)
internal val Res.drawable.ic_chat_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_chat_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chat_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_074_369_796)
internal val Res.drawable.ic_checkmark_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_098_284_848)
internal val Res.drawable.ic_checkmark_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_unchecked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_455_903_981)
internal val Res.drawable.ic_home_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_home_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-261_280_617)
internal val Res.drawable.ic_home_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_home_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-529_714_286)
internal val Res.drawable.ic_insights_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_insights_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_insights_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_557_161_202)
internal val Res.drawable.ic_insights_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_insights_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_insights_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-448_678_580)
internal val Res.drawable.ic_motivational_phrase_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_motivational_phrase_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_motivational_phrase_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_666_012_499)
internal val Res.drawable.ic_motivational_phrase_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_motivational_phrase_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_motivational_phrase_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_459_116_372)
internal val Res.drawable.ic_profile_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_profile_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_profile_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(231_097_514)
internal val Res.drawable.ic_profile_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_profile_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_profile_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(228_193_888)
internal val Res.drawable.ic_splash: DrawableResource by lazy {
      DrawableResource("drawable:ic_splash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_splash.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-74_232_574)
internal val Res.drawable.img_water_footer: DrawableResource by lazy {
      DrawableResource("drawable:img_water_footer", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_water_footer.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_water_footer.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_water_footer.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_chat_default", Res.drawable.ic_chat_default)
  map.put("ic_checkmark_checked", Res.drawable.ic_checkmark_checked)
  map.put("ic_checkmark_unchecked", Res.drawable.ic_checkmark_unchecked)
  map.put("ic_home_default", Res.drawable.ic_home_default)
  map.put("ic_home_selected", Res.drawable.ic_home_selected)
  map.put("ic_insights_default", Res.drawable.ic_insights_default)
  map.put("ic_insights_selected", Res.drawable.ic_insights_selected)
  map.put("ic_motivational_phrase_default", Res.drawable.ic_motivational_phrase_default)
  map.put("ic_motivational_phrase_selected", Res.drawable.ic_motivational_phrase_selected)
  map.put("ic_profile_default", Res.drawable.ic_profile_default)
  map.put("ic_profile_selected", Res.drawable.ic_profile_selected)
  map.put("ic_splash", Res.drawable.ic_splash)
  map.put("img_water_footer", Res.drawable.img_water_footer)
}
